
import {
  CheckCircle,
  Clock,
  FileText,
  XCircle,
  RefreshCw,
} from "lucide-react";



type StatusConfig = {
  color: string;
  icon: React.ElementType;
};

const statusConfig: Record<string, StatusConfig> = {
  Approved: {
    color: "bg-green-100 text-green-800",
    icon: CheckCircle,
  },
  Pending: {
    color: "bg-yellow-100 text-yellow-800",
    icon: Clock,
  },
  Rejected: {
    color: "bg-red-100 text-red-800",
    icon: XCircle,
  },
};

export function getStatusBadge(statusStr: string) {
  const config = statusConfig[statusStr] || statusConfig.Pending;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}
    >
      <Icon className="w-3 h-3 mr-1" />
      {statusStr}
    </span>
  );
}

export const renderTableMessage = (message: string) => (
  <tr>
    <td
      colSpan={8}
      className="px-6 py-12 text-center text-gray-500"
    >
      {message}
    </td>
  </tr>
);

export const renderButtonIcon = (
  loading: boolean,
  Icon: React.ElementType,
) =>
  loading ? (
    <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
  ) : (
    <Icon className="w-4 h-4 mr-2" />
  );

export const getSummaryCards = (
  totalCount: number,
  approvedCount: number,
  pendingCount: number,
  rejectedCount: number,
) => [
  {
    title: "Total Requests",
    count: totalCount,
    icon: FileText,
    textColor: "text-gray-900",
    bgColor: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    title: "Approved",
    count: approvedCount,
    icon: CheckCircle,
    textColor: "text-green-600",
    bgColor: "bg-green-100",
    iconColor: "text-green-600",
  },
  {
    title: "Pending",
    count: pendingCount,
    icon: Clock,
    textColor: "text-yellow-600",
    bgColor: "bg-yellow-100",
    iconColor: "text-yellow-600",
  },
  {
    title: "Rejected",
    count: rejectedCount,
    icon: XCircle,
    textColor: "text-red-600",
    bgColor: "bg-red-100",
    iconColor: "text-red-600",
  },
];